import { apiClient, buildQueryString } from '@/services/utils';

export default {
  getAll(params) {
    const queryString = buildQueryString(params)

    return apiClient.get(`/stitches${queryString}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/api/StitchService.js